import { IOption, Option } from '@/interfaces/field';

export const INTERNET_SKILL = [
    new Option('1', '1 - Muito Ruim'),
    new Option('2', '2 - Ruim'),
    new Option('3', '3 - Média'),
    new Option('4', '4 - Boa'),
    new Option('5', '5 - Muito Boa'),
] as IOption[];